export default __webpack_public_path__ + "static/media/3068.b656c277.jpg";